import { Box, Skeleton as MuiSkeleton, styled } from "@mui/material";

const Root = styled(Box)(({ theme }) => ({
  padding: "40px 46px 40px 46px",

  [theme.breakpoints.down("md")]: {
    padding: "30px 20px",
  },
}));

const Skeleton = styled(MuiSkeleton)({
  borderRadius: 4,
});

export default function PageSkeleton() {
  return (
    <Root>
      <Box display="flex" width="100%" justifyContent="space-between" alignItems="center" mb={6}>
        <Skeleton variant="rectangular" width="40%" height={40} />
        <Skeleton variant="rectangular" width="200px" height={40} />
      </Box>
      <Skeleton variant="rectangular" width="40%" height={120} sx={{ mb: 6 }} />
      <Skeleton variant="rectangular" width="100%" height={8} sx={{ mb: 6 }} />
      <Skeleton variant="rectangular" width="100%" height={72} sx={{ mb: 2 }} />
      <Skeleton variant="rectangular" width="100%" height={62} sx={{ mb: 2 }} />
      <Skeleton variant="rectangular" width="100%" height={62} sx={{ mb: 2 }} />
      <Skeleton variant="rectangular" width="100%" height={62} sx={{ mb: 2 }} />
      <Skeleton variant="rectangular" width="100%" height={62} sx={{ mb: 2 }} />
      <Skeleton variant="rectangular" width="100%" height={62} sx={{ mb: 2 }} />
    </Root>
  );
}
